import { render, staticRenderFns } from "./AttachmentHandler.vue?vue&type=template&id=ee02b268&lang=pug"
import script from "./AttachmentHandler.vue?vue&type=script&lang=js"
export * from "./AttachmentHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports